import {GuidedToursProvider} from '@hconnect/uikit/src/lib2'
import {useUpmPlantContext} from '@hconnect/upm'
import {FeatureFlagKey, useCommonFeatureFlag} from '@hproduce/feature-flags'
import React from 'react'

import {usePlannerTours} from '../../../guidedTours/plannerTours'
import {usePermission} from '../../hooks/permissions/usePermission'

export const PlannerToursProvider = ({children}: {children: React.ReactNode}) => {
  const {plantId} = useUpmPlantContext()
  const tours = usePlannerTours()
  const canSeeCostAvoidance = useCommonFeatureFlag(FeatureFlagKey.CostAvoidance, {plantId}) ?? false
  const canChangeMachinePlan = usePermission('CHANGE_MACHINE_PLAN')

  const isPlannerCostAvoidanceTourAllowed = canSeeCostAvoidance && canChangeMachinePlan

  const enabledTours = {plannerCostAvoidanceTour: isPlannerCostAvoidanceTourAllowed}

  return (
    <GuidedToursProvider tours={tours} enabledTours={enabledTours}>
      {children}
    </GuidedToursProvider>
  )
}
